import { render } from "./PasswordResetSuccess.vue?vue&type=template&id=59149cb6&scoped=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js"

import "./PasswordResetSuccess.vue?vue&type=style&index=0&id=59149cb6&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59149cb6"]])

export default __exports__